import { useEffect, useRef, useState } from "react";

type Variant = "full" | "short" | "hidden";

export function Bismillah({ show }: { show: boolean }) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [variant, setVariant] = useState<Variant>("full");

  useEffect(() => {
    if (!show) return;
    const el = ref.current;
    if (!el) return;
    const parent = el.parentElement;
    if (!parent) return;
    const measure = () => {
      const nav = parent.closest(".sa-public-nav");
      const w = (nav ?? parent).getBoundingClientRect().width;
      if (w < 640) setVariant("hidden");
      else if (w < 980) setVariant("short");
      else setVariant("full");
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(parent);
    return () => ro.disconnect();
  }, [show]);

  if (!show || variant === "hidden") return null;
  return (
    <div
      ref={ref}
      style={{
        fontFamily: "var(--sa-serif)",
        fontStyle: "italic",
        fontSize: 18,
        fontWeight: 600,
        color: "var(--sa-fg)",
        letterSpacing: "0.005em",
        whiteSpace: "nowrap",
        pointerEvents: "none",
        textAlign: "center",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {variant === "full"
        ? "In the name of God, Most Gracious, Most Merciful"
        : "In the name of God"}
    </div>
  );
}
